<div id="carousel-register" *transloco="let t">
  <div [ngSwitch]="currentPageComponent">
    <div *ngSwitchCase="'page-1'">
      <app-header>{{ firstPageLabel }}</app-header>
      <app-paragraph *ngIf="migrating">{{t('business-equipment-migrating-info')}}</app-paragraph>
      <app-business-equipment-form [registerEquipmentFormGroup]="registerService.registerEquipmentFormGroup"
                                   [countryFormGroup]="registerService.countryEquipmentFormGroup"
                                   [phase]="businessEquipmentFormPhase"
                                   [loading]="nextPageLoading"
                                   [feedback]="equipmentRegisterFeedback"
                                   [countries]="registerService.countries"
                                   [equipmentData]="equipmentData"
                                   [privacyLink]="businessRepresentative.privacyPolicyLink || ''"
                                   [(isAddingEquipment)]="isAddingEquipment"
                                   [isRegistration]="!migrating">
      </app-business-equipment-form>
    </div>
    <div *ngSwitchCase="'page-2'">
      <app-header>{{ secondPageLabel }}</app-header>
      <app-paragraph *ngIf="migrating">{{t('business-data-migrating-info')}}</app-paragraph>
      <app-business-data-form [businessData]="businessData">
      </app-business-data-form>
    </div>
    <div *ngSwitchCase="'page-3'">
      <app-header>{{ thirdPageLabel }}</app-header>
      <app-paragraph *ngIf="migrating">{{t('business-representative-migrating-info')}}</app-paragraph>
      <app-business-representative-form [migrating]="migrating" [businessRepresentative]="businessRepresentative"
                                        [animateImage]="creatingAccount">
      </app-business-representative-form>
      <app-checkbox [formGroup]="termsFormGroup"
                    abstractFormControlName="agree"
                    id="register-agree-checkbox"
                    [label]="businessRepresentative.labels.agree"
                    [anchorTermsText]="businessRepresentative.labels.termsAndConditions"
                    [anchorTermsLink]="businessRepresentative.termsAndConditionsLink || ''"
                    [anchorPrivacyText]="businessRepresentative.labels.privacy"
                    [anchorPrivacyLink]="businessRepresentative.privacyPolicyLink || ''"
                    [isNewUser]="true">
      </app-checkbox>
    <app-recaptcha  *ngIf="recaptchaEnabled"
                    id="recaptcha-register"
                    [formGroup]="recaptchaFormGroup"
                    abstractFormControlName="recaptcha"
                    #captchaRef>
    </app-recaptcha>
    </div>
  </div>
  <app-steps [numberOfSteps]="numberOfPages()"
             [activeStep]="activePage">
  </app-steps>
  <app-label *ngIf="errorMessage" isError>{{ errorMessage }}</app-label>
  <div id="button-group">
    <app-primary-button id="carousel-register-back-to-login-click"
                        stroked
                        *ngIf="activePage == 1 && !migrating"
                        (clickAction)="backToLogin()">
      {{ t('cancel-account-creation') }}
    </app-primary-button>
    <app-primary-button id="carousel-register-previous-page-click"
                        stroked
                        *ngIf="activePage > 1"
                        (clickAction)="previousPage()" >
      {{ previousPageLabel }}
    </app-primary-button>
    <app-primary-button id="carousel-register-next-page-click"
                        *ngIf="activePage < numberOfPages() && !nextPageLoading"
                        (clickAction)="nextPage()"
                        (click)="disabledNextPageClick()"
                        [disabled]="isCurrentFormGroupInvalid()">
      {{ t(nextPageLabel)  }}
    </app-primary-button>
    <div *ngIf="nextPageLoading" class="loading">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
    <app-primary-button id="carousel-register-finish-click"
                        *ngIf="hasFinishButton()"
                        [disabled]="isFinishDisabled()"
                        (click)="disabledFinishClick()"
                        (clickAction)="finishAction()">
      {{ finishLabel }}
    </app-primary-button>
  </div>
</div>
